import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  paginationContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  }
}));
